import { AutoComplete, Input } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React, { ReactElement, useEffect, useState } from 'react';
import { useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { searchInPatientList, selectedGlobalSearch, setIsGlobalFilter, setPageIndex, updateDropdownSearchFilter } from '../../../store/actions/inPatientAction';
import { CLAIM_NUMBER_SEARCH_PLACEHOLDER, IPATIENT_CLAIM_NO_SEARCH_KEYS, IPATIENT_SEARCH_KEYS, SEARCH_PLACEHOLDER } from '../../constants/crmConstants';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';

const FilterAutoComplete = React.forwardRef(({ setLoaderStateValue, form }: any, ref: any):
  ReactElement => {
  const {
    selectedInPatientDetail: {
      globalSearch,
      isPreAuthView,
      tpaNextStatus,
    },
  } = useSelector((state: RootState): any => state || {});
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const [searchPlaceholder, setSearchPlaceholder] = useState(
    isPreAuthClaimViewEnabled ? isPreAuthView ? CLAIM_NUMBER_SEARCH_PLACEHOLDER : SEARCH_PLACEHOLDER : SEARCH_PLACEHOLDER);
  const [filterOptions, setFilterOptions] = useState([] as any);
  const [IsFilterSelected, setIsFilterSelected] = useState(true);
  const [openDropDown, setOpenDropDown] = useState(true);
  useEffect((): void => {
    setFilterOptions([]);
    if (globalSearch) {
      setSearchPlaceholder(getPlaceholderName(globalSearch));
    } else {

      setSearchPlaceholder(
        isPreAuthClaimViewEnabled ? isPreAuthView
        ? CLAIM_NUMBER_SEARCH_PLACEHOLDER : SEARCH_PLACEHOLDER : SEARCH_PLACEHOLDER );
    }
  }, [globalSearch, isPreAuthView, tpaNextStatus]);

  useImperativeHandle(
    ref,
    (): any => ({
      setFilterOptions,
      setSearchPlaceholder,
    }),
  );

  const dispatch = useDispatch();

  const changeInputValue = (data: string): void => {
    setOpenDropDown(true);
    setIsFilterSelected(true);
    if (data && data.length > 0) {
    } else {
      dispatch(selectedGlobalSearch(''));
      dispatch(setPageIndex(1));
      dispatch(searchInPatientList());
      dispatch(setIsGlobalFilter(false));
      dispatch(updateDropdownSearchFilter({ ['payerClaimNo']: '' }));
    }
    setSearchPlaceholder(
      isPreAuthClaimViewEnabled ? isPreAuthView
      ? CLAIM_NUMBER_SEARCH_PLACEHOLDER : SEARCH_PLACEHOLDER : SEARCH_PLACEHOLDER );
  };

  const getPlaceholderName = (selectedData: string): string => {
    const [, searchKey] = String(selectedData)?.split('$$');
    const {
      displayName = isPreAuthClaimViewEnabled       // to set the placeholder name for the search field
        ? isPreAuthView
          ? CLAIM_NUMBER_SEARCH_PLACEHOLDER
          : SEARCH_PLACEHOLDER
        : SEARCH_PLACEHOLDER,
    } =
      IPATIENT_CLAIM_NO_SEARCH_KEYS.find(
        ({ key }: any): boolean => key === searchKey,
      ) || {};
    return displayName;
  };

  const selectedDropdownValue = (selectedData: any): void => {
    const searchValue = String(selectedData)?.trim();
    if (isPreAuthView && isPreAuthClaimViewEnabled) {
      customGTMEvent({
        event: 'Claim No. Search',
        'Claim No': searchValue,
      });
      dispatch(updateDropdownSearchFilter({ ['payerClaimNo']: searchValue }));
    } else {
      customGTMEvent({
        event: 'UTR Search',
        UTR: searchValue,
      });
    }
    setSearchPlaceholder(getPlaceholderName(selectedData));
    dispatch(selectedGlobalSearch(selectedData));
    setIsFilterSelected(false);
    dispatch(setIsGlobalFilter(true));
    getSearchedData(searchValue);
    setOpenDropDown(false);
  };

  const getSearchedData = (searchValue: string): void => {
    setLoaderStateValue();
    dispatch(setPageIndex(1));
    if (!searchValue) {
      setIsFilterSelected(true);
      dispatch(selectedGlobalSearch(''));
    }
    dispatch(searchInPatientList());
  };

  const enteredSearchValue = (searchedText: any): any => {
    const searchKeys = (isPreAuthView && isPreAuthClaimViewEnabled) ? IPATIENT_CLAIM_NO_SEARCH_KEYS : IPATIENT_SEARCH_KEYS;
  const optionList = searchKeys
    .map(({ displayName, key }: any): any => ({
      value: `${searchedText}`,
      label: (
        <div style={{ lineHeight: 1.2 }} data-testid={`search-${searchedText}-${key}`}>
          {searchedText}
          <div className="gray-text">
            <small>In {displayName}</small>
          </div>
        </div>
      ),
    }));
    setFilterOptions(searchedText ? optionList : []);
  };

  return (
    <FormItem name="searchValue" className="group-floating-label ant-alignment-margin"
      rules={[{ whitespace: true }]}
    >
      <AutoComplete
        data-testid="autocomplete-search"
        className="w-100 input-control"
        dropdownClassName="certain-category-search-dropdown"
        allowClear={true}
        onSearch={enteredSearchValue}
        options={filterOptions}
        onChange={changeInputValue}
        onSelect={selectedDropdownValue}
        defaultOpen={IsFilterSelected}
        defaultActiveFirstOption={true}
        open={openDropDown}
      >
        <Input placeholder="." className="input-control"
          onBlur={(): void => setOpenDropDown(false)}
          onFocus={(): void => setOpenDropDown(true)}
          suffix={<label className="floating-label" htmlFor="name">{searchPlaceholder}</label>}
        />
      </AutoComplete>
    </FormItem>
  );
});

export default React.memo(FilterAutoComplete);
